import { render, staticRenderFns } from "./HuddleDetailsSkeleton.vue?vue&type=template&id=008f5934&scoped=true"
import script from "./HuddleDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./HuddleDetailsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HuddleDetailsSkeleton.vue?vue&type=style&index=0&id=008f5934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f5934",
  null
  
)

export default component.exports